import { getDirectDebitMandateTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { useClientStore } from '@/stores/client.js'
import { useProjectStore } from '@/stores/project';
import { useIdentityStore } from '@/stores/identity';

export async function buildDataSampleCollection() {
  


  const identity = useIdentityStore();
  const project = useProjectStore();

    //Only show the card to admins as this is an internal task
    if(identity.type !== 'Administrator') return null;

    var milestones = project.milestones;    

    // Check if the trigger milestone (Discovery Exceptions) is completed before showing the Data Sample Collection card
    const triggerMilestone = milestones.find(m => m.type === 'DiscoveryExceptions');
    if(triggerMilestone == null || triggerMilestone.status !== 'SuccessfullyCompleted') {
      return null;
    }

    const milestone = milestones.find(m => m.type === 'DataSampleCollection');
    if(milestone == null) {
      return null;
    }
    
    const card = {
    id: milestone.milestoneId,
    title: 'Sample Data Collection',
    subtitle: 'Retrieve a sample of the customers payroll data, which we will use to create a migration tool.',
    progress: 0,
    subProgressMessage: formatDateToWrittenDate(milestone.scheduledCompletion),
    status: milestone.status,
    route: '/tasks/internal-milestone/' + milestone.milestoneId, 
    createdDate: new Date(milestone.scheduledCompletion)
  }
    
  return card 
}

